import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Popover } from '@mui/material';
import { useBrowserPrint } from '../../../Lib/Hooks/browserPrint.hooks';
import PrinterConfigurationButton from './PrinterConfigurationButtonStatus/PrinterConfigurationButtonStatus';
import PrinterPopover from './PrinterPopover';

const useStyles = makeStyles()(() => ({
  paper: {
    boxShadow: '0px 2px 20px rgba(0, 0, 0, 0.12)',
    borderRadius: '8px',
    padding: '40px 36px 40px 36px',
    width: '376px',
    height: '246px',
  },
}));

function PrinterConfiguration() {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { selectedDevices } = useBrowserPrint();
  const { classes } = useStyles();
  const containerRef = React.useRef<HTMLDivElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <PrinterConfigurationButton
        onClick={handleClick}
        printersSet={
          !!(
            selectedDevices.unitLabel.config &&
            selectedDevices.hangTag.config &&
            selectedDevices.cartonLabel.config
          )
        }
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 50,
          horizontal: -100,
        }}
        classes={classes}
        ref={containerRef}
      >
        <PrinterPopover containerRef={containerRef} />
      </Popover>
    </div>
  );
}

export default PrinterConfiguration;
